
	import Vue from "vue";

	export default Vue.extend({
		name: "TimePickerBuilder",
		props: {
			disabled: {
				type: Boolean,
				default: false,
			},
			label: {
				type: String,
				default: "",
			},
			value: {
				type: String,
				default: "",
			},
		},
		data() {
			return {};
		},
	});
